import React, { createContext } from 'react'

export const ThemeContext = createContext({
  theme: 'light',
  toggleTheme: () => {},
})

export const ThemeContextProvider = ({ children }) => {
  // Theme is now locked to light mode
  const theme = 'light'
  const toggleTheme = () => {} // No-op function for compatibility

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}
